/**
 * Fit text on phones — enlarges headings marked with [data-fit-text] as far as possible
 * without adding a line. The line count is measured at the heading's CSS size, so a
 * one-line heading stays on one line and a two-line heading stays on two.
 *
 * Markup:
 *   [data-fit-text]            — heading to enlarge (phones only, below 48rem).
 *   [data-fit-text-max="48"]   — optional largest size in px (default 2.5× the CSS size).
 */
const MOBILE = window.matchMedia('(max-width: 47.99rem)');

function countLines(el) {
  const range = document.createRange();
  range.selectNodeContents(el);
  const tops = new Set();
  for (const rect of range.getClientRects()) {
    if (rect.width > 0) tops.add(Math.round(rect.top));
  }
  return tops.size;
}

function fit(el) {
  el.style.fontSize = '';
  if (!MOBILE.matches || !el.offsetWidth) return;

  const base = parseFloat(getComputedStyle(el).fontSize);
  const max = parseFloat(el.dataset.fitTextMax) || base * 2.5;
  const lines = countLines(el);
  if (!lines) return;

  let low = base;
  let high = max;
  while (high - low > 0.5) {
    const mid = (low + high) / 2;
    el.style.fontSize = `${mid}px`;
    // Fail when a line is added or a single word overflows the heading box.
    const parentWidth = el.parentElement ? el.parentElement.clientWidth : Infinity;
    if (countLines(el) <= lines && el.scrollWidth <= el.clientWidth + 1 && el.offsetWidth <= parentWidth) low = mid;
    else high = mid;
  }
  el.style.fontSize = `${Math.floor(low)}px`;
}

function fitAll() {
  document.querySelectorAll('[data-fit-text]').forEach(fit);
}

let lastWidth = 0;
const observer = new ResizeObserver(() => {
  // Only width changes can change line breaks; ignore height-only resizes (mobile URL bar).
  const width = document.documentElement.clientWidth;
  if (width === lastWidth) return;
  lastWidth = width;
  fitAll();
});
observer.observe(document.documentElement);

MOBILE.addEventListener('change', fitAll);
document.fonts?.ready.then(fitAll);
fitAll();
